class ImageBannerCollections extends HTMLElement {
  connectedCallback() {
    this.images = this.querySelectorAll('.image-banner-collections__image[data-block-id]');
    this.defaultImage = this.querySelector('.image-banner-collections__image--default');
    this.cards = this.querySelectorAll('.image-banner-collections__card');

    if (!this.cards.length) return;

    this.onCardEnter = this.onCardEnter.bind(this);
    this.onCardLeave = this.onCardLeave.bind(this);

    this.cards.forEach((card) => {
      card.addEventListener('mouseenter', this.onCardEnter);
      card.addEventListener('focusin', this.onCardEnter);
      card.addEventListener('mouseleave', this.onCardLeave);
      card.addEventListener('focusout', this.onCardLeave);
    });
  }

  disconnectedCallback() {
    this.cards.forEach((card) => {
      card.removeEventListener('mouseenter', this.onCardEnter);
      card.removeEventListener('focusin', this.onCardEnter);
      card.removeEventListener('mouseleave', this.onCardLeave);
      card.removeEventListener('focusout', this.onCardLeave);
    });
  }

  onCardEnter(event) {
    const card = event.currentTarget;
    const blockId = card.dataset.blockId;

    this.cards.forEach((item) => item.classList.toggle('is-active', item === card));
    this.setActiveImage(blockId);
  }

  onCardLeave(event) {
    if (event.type === 'focusout' && this.contains(event.relatedTarget)) return;

    this.cards.forEach((item) => item.classList.remove('is-active'));
    this.setActiveImage();
  }

  setActiveImage(blockId) {
    let matched = false;

    this.images.forEach((image) => {
      const isMatch = blockId && image.dataset.blockId === blockId;
      image.classList.toggle('is-active', isMatch);
      if (isMatch) matched = true;
    });

    if (this.defaultImage) {
      this.defaultImage.classList.toggle('is-active', !matched);
    }
  }
}

customElements.define('image-banner-collections', ImageBannerCollections);
